export default __webpack_public_path__ + "static/media/av6.8b4c247b.jpg";